var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchToPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 11.9404C15.3467 12.4404 15.2134 12.9137 14.9734 13.3204C14.84 13.5604 14.66 13.7804 14.46 13.9604C14 14.387 13.3934 14.647 12.72 14.667C11.7467 14.687 10.8867 14.187 10.4134 13.4204C10.16 13.027 10.0067 12.5537 10 12.0537C9.98003 11.2137 10.3534 10.4537 10.9534 9.9537C11.4067 9.58037 11.98 9.34704 12.6067 9.3337C14.08 9.30037 15.3 10.467 15.3334 11.9404Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6267 12.0202L12.3 12.6602L13.6934 11.3135",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11304 4.95996L7.99969 8.36662L13.8464 4.97994",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 14.406V8.35938",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4066 6.11301V9.88637C14.4066 9.9197 14.4066 9.94633 14.3999 9.97967C13.9333 9.573 13.3333 9.33302 12.6666 9.33302C12.0399 9.33302 11.4599 9.55302 10.9999 9.91969C10.3866 10.4064 9.99992 11.1597 9.99992 11.9997C9.99992 12.4997 10.1399 12.973 10.3866 13.373C10.4466 13.4797 10.5199 13.5797 10.5999 13.673L9.37992 14.3464C8.61992 14.773 7.37991 14.773 6.61991 14.3464L3.05992 12.373C2.25325 11.9264 1.59326 10.8064 1.59326 9.88637V6.11301C1.59326 5.19301 2.25325 4.07302 3.05992 3.62636L6.61991 1.65301C7.37991 1.22634 8.61992 1.22634 9.37992 1.65301L12.9399 3.62636C13.7466 4.07302 14.4066 5.19301 14.4066 6.11301Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchToPickup);
export default __webpack_public_path__ + "static/media/switch-to-pickup.409b06ebe98f6ae3f09e63be81b8777f.svg";
export { ForwardRef as ReactComponent };